import { RunTriggerContainer } from "./container";

export const RunTrigger = (props: { enabled: boolean }) => {
  const { enabled } = props;
  return <RunTriggerContainer enabled={enabled} />;
};
